/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// ------------------ COMPONENTES DE BASE--------------------------
import { formatNumberDecimal } from "../../../../../Base/Services/FormatTemplate";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { getLocalDateString } from "../../../../../Base/Services/FechasService";
import { getDateString } from "../../../../../Base/Services/Moment/Luxon";
import { getInformacionEmpresa } from "../../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";
import Loader from "../../../../../Base/Components/Loader/Loader";


// ------------------- CONSULTAS A LA API---------------------------
import { getFirmaPersonal } from "../../../../../API/Payrolls/Firmas/FirmasRequests";
import { getPurchaseSinCancelar } from "../../../../../API/Compras/Requisas/PurchaseRequest";
import { getDatosCompletos } from "../../../../../API/Compras/RequisiscionCompras/PurchaseRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import { RequisasComprasReporteLang } from "./RequisasComprasLang";
import { PDFDocument } from "pdf-lib";
import QRCode from 'qrcode';



pdfMake.vfs = pdfFonts.pdfMake.vfs;


const ReportePR = ({
    showReporte,
    setShowReporte,
    selectedDetalle,
    Language,
    setLanguaje
}) => {
    const [loading, setLoading] = useState(true);
    const [pdfRequisa, setPdfRequisa] = useState([]);
   
    const [pdfUrlCombinado, setPdfUrlCombinado] = useState(null);
    const toast = useRef(null);
  
    const obtenerInformacion = async () => {
      setLoading(true)
      if (selectedDetalle?.length > 0) {
        const infoEmpresaTempo = await getInformacionEmpresa()

        let name = infoEmpresaTempo[0].NombreLegal
        let direccion = infoEmpresaTempo[0]?.Direccion
        let RTNEmpresa = infoEmpresaTempo[0]?.RTN
        let logoB64 = infoEmpresaTempo[0]?.LogoPrimarioB64

        const imgBlanca = await getFirmaPersonal("111");
        const requisasAImprimir = selectedDetalle.slice(0, 20);

        for (const req of requisasAImprimir) {
        const Ids = req.IdPurchaseRequest;

        const resp = await getDatosCompletos(Ids);
        const tempoDetalles = await getPurchaseSinCancelar(req.PurchaseRequest);

        if (resp.length > 0) {
            await GenerarReporte(
            resp[0],
            name,
            direccion,
            RTNEmpresa,
            logoB64,
            imgBlanca,
            tempoDetalles
            );
        }
        }
      }
      setLoading(false);
    };

    // Función para convertir una imagen a base64
    const obtenerImagenPDF = (img) => {
      if (!img || typeof img !== "string") return null;

      const limpia = img.trim();

      if (!limpia) return null;

      if (limpia.startsWith("data:image/")) {
        return limpia;
      }

      return `data:image/png;base64,${limpia}`;
    };

    // Función para crear un objeto de imagen para pdfMake
    const crearImagenFirma = (img) => {
      return img
        ? {
            image: img,
            width: 105,
            height: 70,
            alignment: "center",
            margin: [0, 0, 0, 3],
          }
        : {
            text: "",
            height: 70,
            margin: [0, 0, 0, 3],
          };
    };
  
    const GenerarReporte = async (Datos, name, direccion, RTNEmpresa, logoB64, imgBlanca, tempoDetalles) => {
        const pdfReq = [];
        const firmaCache = new Map();
        
        setLoading(true)

        let Encabezado = Datos
        let Detalles = tempoDetalles

        const UserNameAutorizoGerente = Detalles[0]?.UserNameAutorizoGerente ?? "";
        const UserNameAutorizoBodega = Detalles[0]?.UserNameAutorizoBodega ?? "";
        const UserNameautorizoPlantManager = Detalles[0]?.UserNameAutorizoPlantManager ?? "";
        const UserNameAutorizoFinanzas = Detalles[0]?.UserNameAutorizoFinanzas ?? "";

        const Texturl = await QRCode.toDataURL(`${Encabezado.PurchaseRequest}`, {
          errorCorrectionLevel: "Q",
        });

        const logoPDF = obtenerImagenPDF(logoB64);
        const firmaBlancaPDF = obtenerImagenPDF(imgBlanca);

        const docDefinitionRequisa = {
            pageSize: "LETTER",
            pageOrientation: "portrait",
            pageMargins: [35, 85, 30, 95],

            header: function (currentPage, pageCount, pageSize) {
                return [
                {
                    widths: [200, 350, 20],
                    columns: [
                    [
                        logoPDF
                        ? {
                            image: logoPDF,
                            width: 200,
                            margin: [4, -10, -10, -10],
                            }
                        : {
                            text: "",
                            width: 200,
                            margin: [4, -10, -10, -10],
                            },
                    {},
                    ],
                    [
                        {
                        text: name,
                        style: "titulo2",
                        margin: [-10, 30, 0, 0],
                        width: 320,
                        },
                        {
                        text: direccion,
                        style: "titulo3",
                        margin: [-10, 5, 0, 0],
                        width: 320,
                        fillColor: "#FF0000",
                        },


                    ],
                    [
                        {
                        text: `${getLabel(
                            RequisasComprasReporteLang,
                            "TituloReporte",
                            Language
                        )}\n ${Encabezado?.PurchaseRequest || ""} `,
                        style: "numeroDoc",
                        margin: [0, 40, 0, 0],
                        },
                    ]
                    ],
                },
                ];
            },

            footer: (currentPage, pageCount) => {
                return {
                    table: {
                    widths: [150, 300, 150],
                    body: [
                        [
                        {
                            text:
                            `${getLabel(
                                RequisasComprasReporteLang,
                                "fechaImpresion",
                                Language
                            )}` + getLocalDateString(new Date())
                            + "\n\n" +
                            `${getLabel(
                                RequisasComprasReporteLang,
                                "original",
                                Language
                            )}`
                            + "\n\n" +
                            `${getLabel(
                                RequisasComprasReporteLang,
                                "copia",
                                Language
                            )}\n\n`
                            ,
                            // style: "footer",
                            margin: [30, 20, 5, 0],
                            fontSize: 7.5,
                        },
                        {
                            text: `${getLabel(
                            RequisasComprasReporteLang,
                            "Pagina",
                            Language
                            )} ${currentPage} / ${pageCount}`,
                            alignment: "center",
                            fontSize: 7.5,
                            margin: [0, 20, 0, 0],
                        },
                        {
                            image: Texturl,
                            width: 70,
                            margin: [0, 0, 30, 0],
                            alignment: "right",
                        },
                        ],
                    ]
                    },
                    layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex % 2 === 0) ? '#FFFFFF' : null;
                    },
                    defaultBorder: false,
                    }
                };
            },

            content: [
                {
                    columns: [
                    {
                        margin: [0, 0, 0, 0],
        
                        table: {
                        widths: [250, 20, 250],
                        body: [
                            [
                            {
                                text: `${getLabel(RequisasComprasReporteLang,"fechaCreacion",Language)} ${getDateString(new Date(Encabezado?.DateCreated || ""))}`,
                                border: [false, false, false, false],
                                style: "infoGeneral",
                            },
                            { text: "", border: [false, false, false, false] },
                            { text: ``, border: [false, false, false, false] },
                            ],
                            [
                            {
                                text: `${getLabel(RequisasComprasReporteLang,"area",Language)} ${Encabezado?.Area || ""}`,
                                border: [false, false, false, false],
                                style: "infoGeneral",
                            },
                            { text: "", border: [false, false, false, false] },
                            {
                                text: `${getLabel(RequisasComprasReporteLang,"creadoPor",Language)} ${Encabezado?.UserName || ""}`,
                                border: [false, false, false, false],
                                style: "infoGeneral",
                                alignment: "right",
                            },
                            ],
                            [
                            {
                                text: `${getLabel(RequisasComprasReporteLang,"tipo",Language)} ${Encabezado?.Type || ""}`,
                                border: [false, false, false, true],
                                style: "infoGeneral",
                            },
                            { text: "", border: [false, false, false, true] },
                            {
                                text: `${getLabel(RequisasComprasReporteLang,"solicitadoPor",Language)} ${Encabezado?.UserRequest || ""} `,
                                border: [false, false, false, true],
                                style: "infoGeneral",
                                alignment: "right",
                            },
                            ],
                        ],
                        },
                    },
                    ],
                },
            ],

            styles: {
                tableExample: {
                    margin: [0, 5, 0, 15],
                },
                titulo: {
                    fontSize: 8,
                    // margin: [0, 50, 0, 0],
                    bold: true,
                    alignment: "justify",
                },
                titulo2: {
                    fontSize: 10,
                    // margin: [0, 50, 0, 0],
                    bold: true,
                    alignment: "justify",
                },
                titulo3: {
                    fontSize: 10,
                    // margin: [0, 50, 0, 0],
                    // bold: true,
                    alignment: "justify",
                },
                requisa: {
                    fontSize: 15,
                    // margin: [0, 50, 0, 0],
                    bold: true,
                    alignment: "justify",
                },
                numeroDoc: {
                    fontSize: 10,
                    bold: true,
                    alignment: "center",
                },
                infoGeneral: {
                    fontSize: 8,
                    margin: [-5, 0, 0, 0],
                    // bold: true,
                    // alignment: 'justify'
                },
                infoProveedor: {
                    fontSize: 8,
                    margin: [0, 0, 0, 0],
                },
                header: {
                    fontSize: 6.5,
                    alignment: "center",
                    bold: true,
                },
                headerr: {
                    fontSize: 7,
                    alignment: "center",
                    // bold: true,
                },
                textBody1: {
                    fontSize: 7.5,
                    alignment: "center",
                    // lineHeight: 2
                },
                textBody2: {
                    fontSize: 7,
                    alignment: "right",
                    // lineHeight: 2
                },
                textBody3: {
                    fontSize: 7.5,
                    alignment: "justify",
                    // lineHeight: 2
                },
                textBody4: {
                    fontSize: 8.5,
                    alignment: "justify",
                    // lineHeight: 2
                },
                textTotales: {
                    bold: true,
                    fontSize: 7.5,
                    alignment: "right",
                },
                textCentrado: {
                    fontSize: 7.5,
                    alignment: "center",
                },
                firmas: {
                    fontSize: 8,
                    bold: true,
                    alignment: "center",
                    lineHeight: 1,
                },
                footer: {
                    fontSize: 7.5,
                    alignment: "left",
                    margin: [30, 0, 5, 0],
                },
            },
        };

        
        const detallesPorMoneda = {};
        Detalles.forEach((detalle) => {
            const moneda = detalle.CurrencySymbol || detalle.Currency;
            if (!detallesPorMoneda[moneda]) {
                detallesPorMoneda[moneda] = [];
            }
            detallesPorMoneda[moneda].push(detalle);
        });

        const monedasEntries = Object.entries(detallesPorMoneda);
        monedasEntries.forEach(([moneda, detalles], indexMoneda) => {
            const esUltimaMoneda = indexMoneda === monedasEntries.length - 1;
            const productosMoneda = detalles.map((d) => {
                return [
                { text: d.CodigoProducto, style: "textBody1" },
                { text: d.NombreProducto, style: "textBody3" },
                { text: formatNumberDecimal(d.Quantity), style: "textBody1" },
                { text: d.UnitName, style: "textBody1" },
                { text: formatNumberDecimal(d.Price), style: "textBody2" },
                { text: formatNumberDecimal(d.TAX + d?.ISV18), style: "textBody2" },
                { text: formatNumberDecimal(d.Discount), style: "textBody2" },
                { text: formatNumberDecimal(d.SubTotal), style: "textBody2" },
                { text: formatNumberDecimal(d.Total), style: "textBody2" },
                ];
            });
        
            let numberOfRows = 0;
            numberOfRows += productosMoneda.length;
        
            let numberOfProduct = detalles.reduce(
                (total, detalle) => total + detalle.Quantity,
                0
            );
        
            const subtotalMoneda = detalles.reduce(
                (total, detalle) => total + detalle.SubTotal,
                0
            );
            const descuentoMoneda = detalles.reduce(
                (total, detalle) => total + detalle.Discount,
                0
            );
            const impuestoMoneda = detalles.reduce(
                (total, detalle) => total + detalle.TAX,
                0
            );
            const impuesto18Moneda = detalles.reduce(
                (total, detalle) => total + detalle.ISV18,
                0
            );
            const totalMoneda = detalles.reduce(
                (total, detalle) => total + detalle.Total,
                0
            );
        
            docDefinitionRequisa.content.push(
              {
                    margin: [0, 8, 0, 0],
                    text:
                        `${getLabel(RequisasComprasReporteLang, "detallesEn", Language)}` +
                        `${detalles[0].Currency}`,
                    style: "titulo",
              },
              {
                    margin: [0, 10, 5, 5],
                    table: {
                        widths: [45, 142, 32, 30, 32, 32, 32, 32, 40],
                        body: [
                        [
                            {
                            text: `${getLabel(
                                RequisasComprasReporteLang,
                                "codigo",
                                Language
                            )}`,
                            style: "header",
                            },
                            {
                            text: `${getLabel(
                                RequisasComprasReporteLang,
                                "producto",
                                Language
                            )}`,
                            style: "header",
                            },
                            {
                            text: `${getLabel(
                                RequisasComprasReporteLang,
                                "cantidad",
                                Language
                            )}`,
                            style: "header",
                            },
                            {
                            text: `${getLabel(
                                RequisasComprasReporteLang,
                                "unidad",
                                Language
                            )}`,
                            style: "header",
                            },
                            {
                            text: `${getLabel(
                                RequisasComprasReporteLang,
                                "precio",
                                Language
                            )}`,
                            style: "header",
                            },
                            {
                            text: `${getLabel(
                                RequisasComprasReporteLang,
                                "isv",
                                Language
                            )}`,
                            style: "header",
                            },
                            {
                            text: `${getLabel(
                                RequisasComprasReporteLang,
                                "descuento",
                                Language
                            )}`,
                            style: "header",
                            },
                            { text: `SUBTOTAL`, style: "header" },
                            { text: "TOTAL", style: "header" },
                        ],
                        ...productosMoneda,
                        ],
                    },
                    layout: "lightHorizontalLines",
              },
          
              {
                    margin: [0, 3, 5, 5],
                    table: {
                        widths: [45, 152, 32, 30, 32, 32, 32, 32, 76],
                        body: [
                        [
                            {
                            text: formatNumberDecimal(`${numberOfRows}`),
                            style: "headerr",
                            border: [false, true, false, false],
                            margin: [-20, 0, 0, 0]
                            },
                            {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                            },
                            {
                            text: formatNumberDecimal(`${numberOfProduct}`),
                            style: "headerr",
                            border: [false, true, false, false],
                            },
                            {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                            },
                            {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                            },
                            {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                            },
                            {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                            },
                            {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                            },
                            {
                            text: ``,
                            style: "header",
                            border: [false, true, false, false],
                            },
                        ],
                    ],
                },
                layout: {
                    hLineWidth: function (i) {
                    return 0.05; // Establecer grosor de línea horizontal
                    },
        
                    hLineColor: function (i) {
                    return "#aaa"; // Color de las líneas horizontales
                    },
                },
              },
          
              {
                  margin: [0, 0, 5, 5, 5],
                  table: {
                      widths: [385, 50, 15, 60],
                      body: [
                                [
                                  {
                                    text: esUltimaMoneda
                                      ? `Comentario: ${Encabezado.Comment || ""}`
                                      : "",
                                    style: "titulo",
                                    border: [false, false, false, false],
                                    rowSpan: 4,
                                    alignment: "left",
                                    margin: [0, 5, 20, 0],
                                  },
                                  {
                                    text: "SubTotal",
                                    style: "textTotales",
                                  },
                                  {
                                    text: `${moneda}`,
                                    border: [false, true, false, true],
                                    style: "textTotales",
                                  },
                                  {
                                    text: formatNumberDecimal(subtotalMoneda),
                                    border: [false, true, true, true],
                                    style: "textTotales",
                                  },
                                ],
                            
                                [
                                  {},
                                  {
                                    text: `${getLabel(
                                      RequisasComprasReporteLang,
                                      "descuento",
                                      Language
                                    )}`,
                                    style: "textTotales",
                                  },
                                  {
                                    text: `${moneda}`,
                                    border: [false, true, false, true],
                                    style: "textTotales",
                                  },
                                  {
                                    text: formatNumberDecimal(descuentoMoneda),
                                    style: "textTotales",
                                    border: [false, true, true, true],
                                  },
                                ],
                            
                                [
                                  {},
                                  {
                                    text: `${getLabel(
                                      RequisasComprasReporteLang,
                                      "isv",
                                      Language
                                    )}`,
                                    style: "textTotales",
                                  },
                                  {
                                    text: `${moneda}`,
                                    border: [false, true, false, true],
                                    style: "textTotales",
                                  },
                                  {
                                    text: formatNumberDecimal(
                                      impuestoMoneda + impuesto18Moneda
                                    ),
                                    style: "textTotales",
                                    border: [false, true, true, true],
                                  },
                                ],
                            
                                [
                                  {},
                                  {
                                    text: "Total",
                                    style: "textTotales",
                                  },
                                  {
                                    text: `${moneda}`,
                                    border: [false, true, false, true],
                                    style: "textTotales",
                                  },
                                  {
                                    text: formatNumberDecimal(totalMoneda),
                                    style: "textTotales",
                                    border: [false, true, true, true],
                                  },
                                ],
                      ],
                  },
                  layout: {
                      hLineWidth: function (i) {
                      return 0.05; // Establecer grosor de línea horizontal
                      },
                      vLineWidth: function (i) {
                      return 0.05; // Establecer grosor de línea vertical
                      },
                      hLineColor: function (i) {
                      return "#aaa"; // Color de las líneas horizontales
                      },
                      vLineColor: function (i) {
                      return "#aaa"; // Color de las líneas verticales
                      },
                  },
              }
            );
        });

        const obtenerFirma = async (idPersonal) => {
            if (!idPersonal) return null;
            if (firmaCache.has(idPersonal)) {
                return firmaCache.get(idPersonal);
            }
            const firma = await getFirmaPersonal(idPersonal);
            firmaCache.set(idPersonal, firma);
            return firma;
        };

        let autorizoGerente = await obtenerFirma(Detalles[0]?.IdPersonalAutorizoGerente);
        let autorizoFinanzas = await obtenerFirma(Detalles[0]?.IdPersonalAutorizoFinanzas);
        let autorizoBodega = await obtenerFirma(Detalles[0]?.IdPersonalAutorizoBodega);
        let autorizoPlantaM = await obtenerFirma(Detalles[0]?.IdPersonalAutorizoPlantManager);

        // Convertir las firmas a formato PDF
        const firmaGerentePDF = obtenerImagenPDF(autorizoGerente);
        const firmaFinanzasPDF = obtenerImagenPDF(autorizoFinanzas);
        const firmaBodegaPDF = obtenerImagenPDF(autorizoBodega);
        const firmaPlantaPDF = obtenerImagenPDF(autorizoPlantaM);

        const necesitaFirmaGerente = Detalles.some(detalle => detalle.AutorizaGerente === true);
        const necesitaFirmaBodega = Detalles.some(detalle => detalle.AutorizaBodega === true);
        const necesitaFinanzas = Detalles.some(detalle => detalle.Finanzas === true);

        const crearBloqueFirma = (imagen, titulo, usuario, mostrar = true) => {
          if (!mostrar) {
            return {
              text: "",
              border: [false, false, false, false],
            };
          }
      
          return {
            stack: [
              crearImagenFirma(imagen || firmaBlancaPDF),
              {
                text: "________________________________",
                alignment: "center",
                fontSize: 8,
                margin: [0, 0, 0, 2],
              },
              {
                text: titulo,
                style: "firmas",
              },
              {
                text: usuario || "",
                style: "firmas",
                bold: false,
                margin: [0, 2, 0, 0],
              },
            ],
            border: [false, false, false, false],
          };
        };
    
        // FIRMAS
        const firmasFila1 = [
          crearBloqueFirma(
            firmaGerentePDF,
            getLabel(
              RequisasComprasReporteLang,
              "autorizadoPor",
              Language
            ),
            UserNameAutorizoGerente,
            necesitaFirmaGerente
          ),
      
          crearBloqueFirma(
            firmaBodegaPDF,
            getLabel(
              RequisasComprasReporteLang,
              "Bodega",
              Language
            ),
            UserNameAutorizoBodega,
            necesitaFirmaBodega
          ),
      
          crearBloqueFirma(
            firmaFinanzasPDF,
            getLabel(
              RequisasComprasReporteLang,
              "Finanzas",
              Language
            ),
            UserNameAutorizoFinanzas,
            true
          ),
        ];

        const firmasFila2 = [
          crearBloqueFirma(
            firmaPlantaPDF,
            getLabel(
              RequisasComprasReporteLang,
              "GerentePlanta",
              Language
            ),
            UserNameautorizoPlantManager,
            true
          ),
      
          {
            text: "",
            border: [false, false, false, false],
          },
        ];

        docDefinitionRequisa.content.push({
          margin: [0, 65, 0, 15],
        
          table: {
            widths: ["*", 155, 25, 155, 25, 155, "*"],
        
            dontBreakRows: true,
        
            body: [
              [
                { text: "", border: [false, false, false, false] },
            
                firmasFila1[0],
            
                { text: "", border: [false, false, false, false] },
            
                firmasFila1[1],
            
                { text: "", border: [false, false, false, false] },
            
                firmasFila1[2],
            
                { text: "", border: [false, false, false, false] },
              ],
          
              [
                {
                  text: "",
                  border: [false, false, false, false],
                  margin: [0, 15, 0, 0],
                },
            
                {
                  text: "",
                  border: [false, false, false, false],
                },
            
                {
                  text: "",
                  border: [false, false, false, false],
                },
            
                firmasFila2[0],
            
                {
                  text: "",
                  border: [false, false, false, false],
                },
            
                firmasFila2[1],
            
                {
                  text: "",
                  border: [false, false, false, false],
                },
              ],
            ],
          },
      
          layout: "noBorders",
        });
        
        const docRequisa = pdfMake.createPdf(docDefinitionRequisa);
        await new Promise((resolve) => {
            docRequisa.getDataUrl((url) => {
            pdfReq.push(url);
            resolve();
            });
        });
        
        setLoading(false)
        setPdfRequisa((prev) => [...prev, ...pdfReq]);
    };
  
    const combinarPDFs = async (requisa) => {
      const dataUnida = [...requisa];
  
      if (!dataUnida || dataUnida.length === 0) {
        return;
      }
  
      try {
        const pdfDoc = await PDFDocument.create();
  
        for (const pdfBase64 of dataUnida) {
          const pdfBytes = await fetch(pdfBase64).then((res) =>
            res.arrayBuffer()
          );
          const pdfDocTemp = await PDFDocument.load(pdfBytes);
          const pages = await pdfDoc.copyPages(
            pdfDocTemp,
            pdfDocTemp.getPageIndices()
          );
          pages.forEach((page) => pdfDoc.addPage(page));
        }
  
        const mergedPdfBytes = await pdfDoc.save();
  
        // Crear un Blob y una URL temporal
        const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);
  
        setPdfUrlCombinado(blobUrl); // Seteamos la URL combinada del PDF
      } catch (error) {
        console.error("Error al combinar los PDFs:", error);
      }
    };
  
    useEffect(() => {
      if(pdfRequisa){
        combinarPDFs(pdfRequisa);
      }
    }, [pdfRequisa]);
  
    useEffect(() => {
      if (showReporte) {
        obtenerInformacion();
      }
    }, [showReporte]);
  
    const onHideReporte = () => {
      setShowReporte(false);
      setLanguaje('es')
    };
  
    return (
      <Dialog
        visible={showReporte}
        onHide={onHideReporte}
        style={{ width: "63vw", height: "85vh" }}
      >
        <Loader loading={loading}/>
        <Toast ref={toast} />
        <div>
          {!loading && pdfUrlCombinado && (
            <iframe
              src={pdfUrlCombinado}
              style={{ width: "60vw", height: "75vh", border: "1px solid #ccc" }}
              id="foo"
              title="Reporte QR PDF"
            />
          )}
        </div>
      </Dialog>
    );
};
  
  export default ReportePR;
  